import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTestimonials } from '../../Apis/content';

export const Testimonials = createAsyncThunk('testimonails', async (formData, { rejectWithValue }) => {
    try {
        const response = await getTestimonials(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const testSlice = createSlice({
    name: 'test',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearTestStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Testimonials.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Testimonials.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Testimonials.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearTestStatus } = testSlice.actions;
export default testSlice.reducer;

